
/**
 * Module dependencies.
 */

import { ReactNode } from 'react';
import AnimateHeight from 'react-animate-height';

/**
 * `Props` type.
 */

type Props = {
  children: ReactNode;
  initialHeight?: number;
  isOpen?: boolean;
};

/**
 * Export `Collapse` component.
 */

export function Collapse(props: Props): JSX.Element {
  const { children, initialHeight = 0, isOpen, ...rest } = props;

  return (
    <AnimateHeight
      {...rest}
      duration={500}
      height={isOpen ? 'auto' : initialHeight}
    >
      {children}
    </AnimateHeight>
  );
}
